import SchoolService from "../services/SchoolService";
import SearchService from "../services/SearchService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
  count: 0,
  selectedSchool: "",
  selectedSchoolName: "",
  school: {
    id: null,
    uuid: "",
    school_name: "",
    main_languages: [],
    languages_of_instruction: [],
    mongo_id: "",
    future_primary_school: "",
    registered_with_govt: false,
    photo: "",
    emis_id: "",
    country: "",
    region: "",
    district: "",
    village: "",
    lat: null,
    lng: null,
    address: "",
    type: "",
    trainer:""
  },
  finance: {
    id: "",
    finance_date: null,
    currency: "",
    fees: "",
    fees_parents: "",
    gov_salaries: "",
    gov_grants: "",
    ad_hoc_gov_funding: "",
    other: "",
  },
  financings: [],
  structure: {},
  structures: [],
  populations: [],
  schools: [],
  schoolTeachers: [],
  schoolsExport: [],
});

const schools = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    count(state, val) {
      state.count = val;
    },
    school_name(state, val) {
      state.school.school_name = val;
    },
    type(state, val) {
      state.school.type = val;
    },
    emis_id(state, val) {
      state.school.emis_id = val;
    },
    languages_of_instruction(state, val) {
      state.school.languages_of_instruction = val;
    },
    main_languages(state, val) {
      state.school.main_languages = val;
    },
    country(state, val) {
      state.school.country = val;
    },
    region(state, val) {
      state.school.region = val;
    },
    district(state, val) {
      state.school.district = val;
    },
    village(state, val) {
      state.school.village = val;
    },
    lat(state, val) {
      state.school.lat = val;
    },
    lng(state, val) {
      state.school.lng = val;
    },
    address(state, val) {
      state.school.address = val;
    },
    selectedSchool(state, val) {
      state.selectedSchool = val;
    },
    finance_id(state, val) {
      state.finance.id = val;
    },
    finance_date(state, val) {
      state.finance.finance_date = val;
    },
    fees(state, val) {
      state.finance.fees = val;
    },
    currency(state, val) {
      state.finance.currency = val;
    },
    gov_grants(state, val) {
      state.finance.gov_grants = val;
    },
    fees_parents(state, val) {
      state.finance.fees_parents = val;
    },
    gov_salaries(state, val) {
      state.finance.gov_salaries = val;
    },
    ad_hoc_gov_funding(state, val) {
      state.finance.ad_hoc_gov_funding = val;
    },
    other(state, val) {
      state.finance.other = val;
    },
    schools(state, val) {
      state.schools = val;
    },
    financings(state, val) {
      state.financings = val;
    },
    structure(state, val) {
      state.structure = val;
    },
    structures(state, val) {
      state.structures = val;
    },
    populations(state, val) {
      state.populations = val;
    },
    schoolTeachers(state, val) {
      state.schoolTeachers = val;
    },
    trainer(state, val) {
      state.school.trainer = val;
    },
    resetSchools(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async RESET_SCHOOLS_STATE(context) {
      await context.commit("resetSchools");
    },
    async GET_SCHOOLS(context) {
      // console.log("auth: ", context.rootState.auth);
      let data = [];
      try {
        if (context.rootState.auth.user.admin) {
          // console.log("fetching all schools");
          const res = await SchoolService.fetchSchools();
          data = res.data.schools;
        }else if (context.rootState.auth.user.src) {
          const user_uuid = context.rootState.auth.user.uuid;
          const res = await SchoolService.fetchClusterSchools(user_uuid);
          data = res.data.schools;
        } else if (context.rootState.auth.coordinator.uuid.length > 0) {
          // console.log(
          //   "fetching coordinator schools for:",
          //   context.rootState.auth.coordinator
          // );
          const res = await SchoolService.fetchCoordinatorSchools(
            context.rootState.auth.coordinator.uuid
          );
          data = res.data.schoolsFull;
        } else {
          // console.log("fetching trainer schools");
          // console.log(context.rootState.auth);
          const res = await SchoolService.fetchTrainerSchools(
            context.rootState.auth.trainer.uuid
          );
          data = res.data.schools;
        }
      } catch (e) {}
      context.commit("schools", data);
    },
    async SEARCH_SCHOOLS(context) {
      const table = "schools";
      const res = await SearchService.searchName(
        table,
        context.rootState.searches.name
      );
      const data = await res.data.results;
      context.commit("schools", data);
    },
    async GET_SCHOOL_NAMES(context) {
      const res = await SchoolService.fetchSchoolNames();
      const data = res.data.schools;
      context.rootState.schools.schools = data;
    },
    async GET_SCHOOLS_EXPORT(context) {
      const res = await SchoolService.fetchSchoolsExport();
      const data = res.data.schools;
      context.rootState.schools.schoolsExport = data;
    },
    async GET_SCHOOL(context) {
      const school = await SchoolService.getSchool({
        id: router.currentRoute.params.id,
      });
      const data = school.data.school[0];
      context.rootState.schools.school = data;
    },
    async CREATE_SCHOOL({ state }) {
      state.school.uuid = uuidv4();
      await SchoolService.addSchool(state.school);
    },
    async UPDATE_SCHOOL({ state }) {
      await SchoolService.updateSchool(state.school);
    },
    async GET_TRAINER_SCHOOLS(context) {
      const schools = await SchoolService.fetchSchoolsByTrainer({
        id: context.rootState.observations.observation.trainer,
      });
      const data = schools.data.trainers;
      context.rootState.schools.schools = data;
    },
    async GET_TRAINER_WS_SCHOOLS(context) {
      const schools = await SchoolService.fetchSchoolsByTrainer({
        id: context.rootState.workshops.workshop.trainer,
      });
      const data = schools.data.schools;
      context.rootState.schools.schools = data;
    },
    async GET_SCHOOL_POPULATIONS(context) {
      const populations = await SchoolService.fetchSchoolPopulations({
        id: router.currentRoute.params.id,
      });
      const data = populations.data.results;
      context.commit("populations", data);
    },
    async GET_SCHOOL_FINANCINGS(context) {
      const financings = await SchoolService.fetchSchoolFinancings({
        id: router.currentRoute.params.id,
      });
      const data = financings.data.schoolFinancing;
      context.commit("financings", data);
    },
    async CREATE_SCHOOL_FINANCINGS({ state }) {
      await SchoolService.createSchoolFinancing(state.financing);
    },
    async UPDATE_SCHOOL_FINANCINGS({ state }) {
      await SchoolService.updateSchoolFinancing(state.financing);
    },
    async GET_SCHOOL_STRUCTURES(context) {
      const payload = await SchoolService.fetchSchoolStructures({
        id: router.currentRoute.params.id,
      });
      const data = payload.data.results;
      context.commit("structures", data);
    },
    async GET_SCHOOL_STRUCTURE(context, structureId) {
      const payload = await SchoolService.fetchSchoolStructure({
        id: router.currentRoute.params.id,
        structureId,
      });
      const data = payload.data.results;
      context.commit("structure", data);
    },
    async CREATE_SCHOOL_STRUCTURES({ state }) {
      await SchoolService.createSchoolStructure(state.structure);
    },
    async UPDATE_SCHOOL_STRUCTURES({ state }) {
      await SchoolService.updateSchoolStructure(state.structure);
    },
    async GET_SCHOOL_TEACHERS(context) {
      const school = await SchoolService.fetchSchoolTeachers({
        id: router.currentRoute.params.id,
      });
      const data = school.data.teachers;
      await context.commit("schoolTeachers", data);
    },
    async GET_SCHOOL_COUNT(context) {
      const payload = await SchoolService.fetchSchoolCount();
      const { count } = payload.data.results;
      context.commit("count", parseInt(count));
    },
  },
  getters: {
    getSelectedSchool: (state) => state.selectedSchool,
    getRegion: (state) => state.school.region,
    getDistrict: (state) => state.school.district,
    getSchoolName: (state) => state.school.school_name,
  },
};

export default schools;
